const IconBase = ({
  size = 24,
  color = "#000000",
  viewBox = "0 0 24 24",
  children,
  ...rest
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox={viewBox}
      fill="none"
      color={color}
      {...rest}
    >
      {children}
    </svg>
  );
};

export default IconBase;
